import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { BiGitBranch } from 'react-icons/bi';

function PathSelectionModal({ show, onSelect, onCancel }) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <BiGitBranch className="me-2 mb-1" />
          Select Path
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
          Choose which path to add the next step to:
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center gap-3">
        <Button
          variant="success"
          size="lg"
          onClick={() => onSelect('true')}
          style={{ minWidth: '150px' }}
        >
          <span className="fw-bold">True Path</span>
        </Button>
        <Button
          variant="warning"
          size="lg"
          onClick={() => onSelect('false')}
          style={{ minWidth: '150px' }}
        >
          <span className="fw-bold">False Path</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PathSelectionModal;
